import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import { VehiclePopulationComponentProps } from '../../types/vehicle-population-component.props';
import { VinFilterComponent } from '../vin-filter-component/vin-filter-component';
import { onAddOrRemoveButtonClick } from './utils/on-add-or-remove-button-click/on-add-or-remove-button-click';
import { onChangeVinCriterion } from './utils/on-change-vin-criterion/on-change-vin-criterion';

export const CampaignVinFiltersContainer: FunctionComponent<
  VehiclePopulationComponentProps
> = (props: PropsWithChildren<VehiclePopulationComponentProps>) => {
  const { values, setFieldValue, handleBlur } = props;

  return (
    <FormControl
      data-testid="vin-criteria-form-control"
      className="not-centered"
    >
      {values.vinCriteria &&
        values.vinCriteria.length > 0 &&
        values.vinCriteria.map((vinCriterion, index) => (
          <VinFilterComponent
            key={index}
            filterIndex={index}
            isLastElement={index === values.vinCriteria.length - 1}
            vinCriterion={vinCriterion}
            onChangeVinCriterion={onChangeVinCriterion(
              values.vinCriteria,
              setFieldValue
            )}
            handleBlur={handleBlur}
            onAddOrRemoveButtonClick={onAddOrRemoveButtonClick(
              values.vinCriteria,
              setFieldValue
            )}
          />
        ))}
    </FormControl>
  );
};
